/* THIS FILE IS GENERATED. DO NOT EDIT */

import { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { mergeProps } from '@/utils/merge';
import StandaloneTwitter from 'base/components/standalone/Twitter';

export const DynamicStandaloneTwitter = StandaloneTwitter;
export type DynamicStandaloneTwitterProps = PropsFromComponent<typeof StandaloneTwitter>;

export const DynamicStandaloneTwitterWith = (extras: DynamicStandaloneExtras): typeof StandaloneTwitter => {
    return function DynamicStandaloneTwitter(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'Twitter');
        return <StandaloneTwitter {...mergeProps({ options: { theme } }, props)} />;
    }
}